import type { ReactNode } from 'react';
import { Button, ButtonVariants } from '@components/button/Button';
import { Modal } from '@components/modal/Modal';
import { ModalActions } from '@components/modal/ModalActions';

interface NavigationWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  modalMessage: ReactNode;
  confirmButtonText?: string;
  rejectButtonText?: string;
  handleSaveChangesClick: () => void;
  handleLoseChangesClick: () => void;
}

export const NavigationWarningModal = ({
  isOpen,
  onClose,
  modalMessage,
  confirmButtonText = 'Save changes and proceed',
  rejectButtonText = 'Lose changes and proceed',
  handleSaveChangesClick,
  handleLoseChangesClick,
}: NavigationWarningModalProps) => {
  return (
    <Modal
      ariaLabel="Navigation Warning Modal"
      isOpen={isOpen}
      onClose={onClose}
    >
      {modalMessage}

      <ModalActions>
        <Button
          label={confirmButtonText}
          onClick={handleSaveChangesClick}
          variant={ButtonVariants.Primary}
        />
        <Button
          label={rejectButtonText}
          onClick={handleLoseChangesClick}
          variant={ButtonVariants.Tertiary}
        />
      </ModalActions>
    </Modal>
  );
};
